module.exports = __webpack_public_path__ + "static/media/ArrowLeft.1d2e9faa.svg";